import { Cohort, PathwayTemplate } from '../types/pathway'

export const pathwayTemplates: PathwayTemplate[] = [
  {
    id: 'new-manager-foundations',
    name: 'New Manager Foundations',
    audience: 'new-manager',
    summary:
      'For individual contributors recently promoted into their first people-leadership role.',
    terms: ['leadership', 'delegation', 'feedback', 'communication'],
    moduleIds: [
      'active-empathetic-listening',
      'adapting-leadership-styles',
      'delegation-empowerment',
      'feedback-that-lands',
      'difficult-conversations',
      'coaching-for-performance',
    ],
  },
  {
    id: 'leading-through-reorg',
    name: 'Leading Through a Reorg',
    audience: 'mid-level',
    summary:
      'For managers holding teams together during restructuring, mergers, or a new operating model.',
    terms: ['change management', 'communication', 'retention'],
    moduleIds: [
      'leading-effective-communication',
      'leading-through-change',
      'communicating-change',
      'managing-resistance',
      'high-performing-teams',
    ],
  },
  {
    id: 'retention-and-engagement',
    name: 'Retention and Engagement',
    audience: 'mid-level',
    summary:
      'For organizations losing people faster than they can replace them, starting with the manager relationship.',
    terms: ['retention', 'coaching', 'emotional intelligence'],
    moduleIds: [
      'emotional-intelligence',
      'active-empathetic-listening',
      'coaching-for-performance',
      'feedback-that-lands',
      'high-performing-teams',
    ],
  },
  {
    id: 'executive-readiness',
    name: 'Executive Readiness',
    audience: 'senior-leader',
    summary:
      'For directors and VPs being prepared for enterprise-level scope and board exposure.',
    terms: ['executive presence', 'strategic thinking', 'business acumen'],
    moduleIds: [
      'reading-leading-room',
      'executive-presence',
      'enhancing-business-outcomes',
      'strategic-decision-making',
      'organizational-transformation',
    ],
  },
]

export const cohorts: Cohort[] = [
  {
    id: 'meridian-new-mgrs',
    name: 'Newly promoted managers',
    organization: 'Meridian Health',
    size: 24,
    level: 'new-manager',
  },
  {
    id: 'meridian-directors',
    name: 'Director cohort, FY26',
    organization: 'Meridian Health',
    size: 12,
    level: 'senior-leader',
  },
  {
    id: 'northwind-ops',
    name: 'Operations leadership',
    organization: 'Northwind Logistics',
    size: 38,
    level: 'mid-level',
  },
  {
    id: 'atlas-exec',
    name: 'Executive team',
    organization: 'Atlas Manufacturing',
    size: 9,
    level: 'c-suite',
  },
]
